var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M.332.909A.966.966 0 0 0 .31 2.25l7.928 8.415a.91.91 0 0 0 1.31.023l8.216-8.133a.96.96 0 0 0 .284-.667.958.958 0 0 0-.26-.676.91.91 0 0 0-1.31-.022l-7.55 7.472L1.643.932A.91.91 0 0 0 .333.909z"
  })));
};
export default SvgArrowDown;